import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import ErrorBoundary from "@/components/ErrorBoundary";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import HomePage from "@/pages/Home";
import AboutPage from "@/pages/About";
import ServiceDetail from "@/pages/ServiceDetail";
import BlogPage from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import ContactPage from "@/pages/Contact";
import AdminBlog from "@/pages/AdminBlog";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const MainLayout = ({ children }) => (
  <>
    <Header />
    <main className="min-h-screen">{children}</main>
    <Footer />
  </>
);

function App() {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <div className="App">
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              {/* Admin route without header/footer */}
              <Route path="/admin/blog" element={<AdminBlog />} />
              
              {/* Main routes with header/footer */}
              <Route path="/" element={<MainLayout><HomePage /></MainLayout>} />
              <Route path="/about" element={<MainLayout><AboutPage /></MainLayout>} />
              <Route path="/services/:slug" element={<MainLayout><ServiceDetail /></MainLayout>} />
              <Route path="/blog" element={<MainLayout><BlogPage /></MainLayout>} />
              <Route path="/blog/:slug" element={<MainLayout><BlogPost /></MainLayout>} />
              <Route path="/contact" element={<MainLayout><ContactPage /></MainLayout>} />
            </Routes>
            <Toaster position="top-right" richColors />
          </BrowserRouter>
        </div>
      </HelmetProvider>
    </ErrorBoundary>
  );
}

export default App;
